import styled from 'styled-components'

import { Flex } from 'app/components/design-system-components'

export const StyledReportingSettingContainer = styled(Flex)`
  width: 100%;
  @media (max-width: 991px) {
    flex-direction: column;
  }

  .col-first {
    flex: 0 0 60%;
    width: 60% !important;

    @media (max-width: 991px) {
      width: 100% !important;
    }
  }

  .col-second {
    flex: 0 0 40%;

    @media (max-width: 991px) {
      width: 100%;
    }
  }
`
